export type CombinedNdtSelection = {
  wpsNumber?: string[] | string | null;
  wallThickness?: string[] | string | null;
  location?: string[] | string | null;
};

function toFilterArray(value: string[] | string | null | undefined): string[] | null {
  if (value == null) return null;
  if (Array.isArray(value)) return value.length > 0 ? value : null;
  return value !== '' ? [String(value)] : null;
}

function toPipeIdApi(pipeIds: string[]): number | number[] | null {
  const ids = pipeIds.map(Number).filter((id) => !Number.isNaN(id));
  if (ids.length === 0) return null;
  if (ids.length === 1) return ids[0];
  return ids;
}

/** Summary and ML-insights payload. Empty filters mean every pipe, matching NDT Analytics. */
export function toNdtSummaryPayload(
  projectId: string | number | null,
  pipeIds: string[],
  selection: CombinedNdtSelection,
  options?: { allPipes?: boolean },
) {
  const wps = toFilterArray(selection.wpsNumber);
  const allPipes = options?.allPipes || pipeIds.length === 0;
  return {
    project: projectId,
    pipe_id: allPipes ? null : toPipeIdApi(pipeIds),
    sub_project: wps,
    pipe_diameter: null,
    wall_thickness: toFilterArray(selection.wallThickness),
    shift: null,
    location: toFilterArray(selection.location),
    critical_weld: null,
    wps_number: wps,
    welder_number: null,
    welder_repair_number: null,
    evaluation: null,
    defect_type: null,
    start_date: null,
    end_date: null,
    limit: null,
  };
}
